import React from "react";
import InputText from "../ReusableComponents/InputText";

const SalaryPaidPopup = ({ data }) => {
  
  const salary = data || {};

  // Debugging
  console.log("popUpData:", data);

  return (
    <div className="p-6">
      <div className="grid gap-4 mb-6 md:grid-cols-3">
        {/* Date */}
        <InputText
          inputType="date"
          title="Date"
          content={(salary?.SalaryDate ?? "").split("T")[0] || ""}
          classStar="text-red-500"
          name="salaryDate"
          disabled="disabled"
        />

        {/* Staff Name Input */}
        <InputText
          inputType="text"
          title="Staff Name"
          name="staffName"
          content={salary.StaffName || ""}
          classStar="text-red-500"
          disabled="disabled"
        />

        {/* Grade */}
        <InputText
          inputType="text"
          title="Grade"
          name="grade"
          content={salary.Grade || ""}
          disabled="disabled"
        />

        {/* Gross Salary Section */}
        <div className="font-semibold col-span-3">Gross Salary</div>
        <InputText inputType="number" title="Basic Salary" name="basicSalary" content={salary.BasicSalary || "0"} disabled />
        <InputText inputType="number" title="DA" name="da" content={salary.DA || "0"} disabled />
        <InputText inputType="number" title="HRA" name="hra" content={salary.HRA || "0"} disabled />
        <InputText inputType="number" title="Convenience" name="convenience" content={salary.Convenience || "0"} disabled />
        <InputText inputType="number" title="Medical" name="medical" content={salary.Medical || "0"} disabled />
        <InputText inputType="number" title="Performance" name="performance" content={salary.Performance || "0"} disabled />
        <InputText inputType="number" title="Others" name="others" content={salary.Others || "0"} disabled />
        <InputText inputType="number" title="Total Gross" name="grossSalaryTotal" content={salary.GrossSalaryTotal || "0"} disabled />

        {/* Deductions Section */}
        <div className="font-semibold col-span-3">Deductions</div>
        <InputText inputType="number" title="PF" name="pf" content={salary.PF || "0"} disabled />
        <InputText inputType="number" title="ESI" name="esi" content={salary.ESI || "0"} disabled />
        <InputText inputType="number" title="Insurance" name="insurance" content={salary.Insurance || "0"} disabled />
        <InputText inputType="number" title="Loan" name="loan" content={salary.Loan || "0"} disabled />
        <InputText inputType="number" title="Tax" name="tax" content={salary.Tax || "0"} disabled />
        <InputText inputType="number" title="Total Deductions" name="deductionsTotal" content={salary.DeductionsTotal || "0"} disabled />
        <InputText inputType="number" title="Net Total" name="nettotal" content={salary.NetTotal || "0"} disabled />

        {/* Attendance Section */}
        <div className="font-semibold col-span-3">Attendance</div>
        <InputText inputType="number" title="Working Days" name="workingDays" content={salary.WorkingDays || "26"} disabled />
        <InputText inputType="number" title="Present Days" name="presentDays" content={salary.PresentDays || "26"} disabled />
        <InputText inputType="number" title="Leave Days" name="leaveDays" content={salary.LeaveDays || "0"} disabled />
        <InputText inputType="number" title="Absent Days" name="absentDays" content={salary.AbsentDays || "0"} disabled />

        {/* Final Paid Section */}
        <div className="font-semibold col-span-3">Final Salary Paid</div>
        <InputText inputType="number" title="Amount to be Paid" name="totalAmounttobePaid" content={salary.TotalAmounttobePaid || "0"} disabled />
      </div>
    </div>
  );
};

export default SalaryPaidPopup;